import { IoArrowBackOutline } from "react-icons/io5";

const BackHeader = ({ title, onBack, hideBack = false }) => {
  return (
    <div className="flex items-center relative">
      {/* Back Button — visible by default */}
      {!hideBack && (
        <button
          onClick={onBack}
          className="absolute left-0 flex items-center justify-center p-2 
          rounded-full text-text-secondary hover:text-primary-navy 
          hover:bg-primary-navy/10 active:scale-95 transition-all duration-200"
        >
          <IoArrowBackOutline className="w-5 h-5 xl:w-7 xl:h-7" />
        </button>
      )}

      {/* Title */}
      <h1
        className="text-lg sm:text-xl flex-1 text-center font-medium 
      text-text-primary my-3 sm:my-6"
      >
        {title}
      </h1>
    </div>
  );
};

export default BackHeader;
